import axios from "axios";
import { toast } from "react-toastify";
import { getUrl } from "./urls";
import { getAccessToken } from "./utils";

export const CONFIGURE_TOPICS = "CONFIGURE_TOPICS";
export const SWITCH_TAB = "SWITCH_TAB";
export const FETCH_CHART_METRICS = "FETCH_CHART_METRICS";
export const FETCH_OCR_WORDCLOUD_DATA = "FETCH_OCR_WORDCLOUD_DATA";
export const RECOMMENDATION_DATA = "RECOMMENDATION_DATA";
export const RECOMMENDATION_DATA_LIST = "RECOMMENDATION_DATA_LIST";
export const CONFIG_RECOMMENDATION_FILTER_LIST = "CONFIG_RECOMMENDATION_FILTER_LIST";
export const DATA_CLEANUP = "DATA_CLEANUP";
export const TOGGLE_TAB_DIMENSION = "TOGGLE_TAB_DIMENSION";

export function fetchQueryLists() {
    let res = axios({
        method: "get",
        url: `${getUrl("query_list")}&access-token=${getAccessToken()}&includes=topicsAndSubtopics`,
        headers: {
            "Content-Type": "application/json",
        },
    })
        .then((res) => {
            return res.data;
        })
        .catch((err) => {
            toast.error(err.response.data.message);
            return err;
        });
    return {
        type: "INSIGHTS_QUERY_LIST",
        payload: res,
    };
}

export const configureBrands = (topics) => {
    return {
        type: CONFIGURE_TOPICS,
        payload: topics,
    };
};

export const switchMainTab = (tab) => {
    return {
        type: SWITCH_TAB,
        payload: tab,
    };
};

export const minimizeInsightsTab = (bool) => {
    return {
        type: TOGGLE_TAB_DIMENSION,
        payload: bool,
    };
};
export const cleanupData = () => {
    return {
        type: DATA_CLEANUP,
    };
};

export const fetchChartData = (data) => {
    let chart_name = data["chart_name"];
    let topic_name = data["topic_name"];

    delete data["chart_name"];
    delete data["topic_name"];

    return function (dispatch) {
        dispatch({
            type: "FETCH_OCR_WORDCLOUD_DATA_PENDING",
            payload: { chart_name: chart_name, topic_name: topic_name },
        });
        let resp = axios({
            method: "post",
            url: getUrl("top_influencers_chart"),
            data,
            headers: {
                // "Content-Type": "application/json",
            },
        })
            .then((res) => {
                dispatch({
                    type: "FETCH_OCR_WORDCLOUD_DATA_FULFILLED",
                    payload: { chart_name: chart_name, topic_name: topic_name, response: res.data },
                });
            })
            .catch((err) => {
                toast.error(err.response?.data?.message);
                dispatch({
                    type: "FETCH_OCR_WORDCLOUD_DATA_FULFILLED",
                    payload: { chart_name: chart_name, topic_name: topic_name },
                });
            });
    };
};

export const fetchChartDataWithSearchApi = (data) => {
    let chart_name = data["chart_name"];
    let topic_name = data["topic_name"];
    let topicsObject = data["topicsObject"];

    delete data["chart_name"];
    delete data["topic_name"];
    delete data["topicsObject"];

    let url = getUrl("searchaggs");
    if (chart_name === "product-attributes" || chart_name === "brand-comparision") url = `${getUrl("searchaggs")}&apiWrapperIdentifiers=dataByTopic`;

    return function (dispatch) {
        dispatch({
            type: "FETCH_OCR_WORDCLOUD_DATA_PENDING",
            payload: { chart_name: chart_name, topic_name: topic_name },
        });
        let resp = axios({
            method: "post",
            url,
            data,
            headers: {
                "Content-Type": "application/json",
            },
        })
            .then((res) => {
                dispatch({
                    type: "FETCH_OCR_WORDCLOUD_DATA_FULFILLED",
                    payload: { chart_name: chart_name, topic_name: topic_name, response: res.data, params: { data, topicsObject } },
                });
            })
            .catch((err) => {
                toast.error(err.response?.data?.message);
                dispatch({
                    type: "FETCH_OCR_WORDCLOUD_DATA_REJECTED",
                    payload: { chart_name: chart_name, topic_name: topic_name },
                });
            });
    };
};

export const fetchChartDataWithRecommendationApi = (data) => {
    let chart_name = data["chart_name"];
    let topic_name = data["topic_name"];
    delete data["chart_name"];
    delete data["topic_name"];
    let res = axios({
        method: "POST",
        url: `${getUrl("recommendation")}`,
        headers: {
            "Content-Type": "application/json",
            "access-token": getAccessToken(),
            cache: false,
        },
        data,
    })
        .then((res) => {
            return { chart_name: chart_name, topic_name: topic_name, response: res.data, params: data };
        })
        .catch((err) => {
            toast.error(err.response?.data?.message);
            return err.response;
        });

    return {
        type: "RECOMMENDATION_DATA",
        payload: res,
    };
};

export function fetchRecommendationLists(data, recommendation_type, val) {
    let chart_name = data["chart_name"];
    let topic_name = data["topic_name"];
    delete data["chart_name"];
    delete data["topic_name"];
    let res = axios({
        method: "get",
        url: `${getUrl("recommendation")}?recommendation_type=${recommendation_type}&refresh=${val}&access-token=${getAccessToken()}`,
        headers: {
            "Content-Type": "application/json",
        },
    })
        .then((res) => {
            return { chart_name: chart_name, topic_name: topic_name, response: res.data };
        })
        .catch((err) => {
            toast.error(err.response?.data?.message);
            return err;
        });

    return {
        type: "RECOMMENDATION_DATA_LIST",
        payload: res,
    };
}

export const configRecommendationFilter = (data) => {
    let res = axios({
        method: "POST",
        url: `${getUrl("recommendation_filter")}/configure?access-token=${getAccessToken()}`,
        headers: {
            "Content-Type": "application/json",
            "access-token": getAccessToken(),
            cache: false,
        },
        data,
    })
        .then((res) => {
            toast.success("Topics configured successfully");
            return res.data;
        })
        .catch((err) => {
            toast.error(err.response?.data?.message);
            return err.response;
        });

    return {
        type: "CONFIG_RECOMMENDATION_FILTER",
        payload: res,
    };
};

export const getConfigRecommendationFilterList = () => {
    let res = axios({
        method: "get",
        url: `${getUrl("recommendation_filter")}?access-token=${getAccessToken()}`,
        headers: {
            "Content-Type": "application/json",
            "access-token": getAccessToken(),
            cache: false,
        },
        // data,
    })
        .then((res) => {
            return res.data;
        })
        .catch((err) => {
            toast.error(err.response?.data?.message);
            return err.response;
        });

    return {
        type: "CONFIG_RECOMMENDATION_FILTER_LIST",
        payload: res,
    };
};
